import { render } from "./ViewInvoices.vue?vue&type=template&id=385be915"
import script from "./ViewInvoices.vue?vue&type=script&lang=js"
export * from "./ViewInvoices.vue?vue&type=script&lang=js"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__